import { IconProps } from "@/data/types"

export default function DollarIcon({ width=30, height=30, color='#A58760', className }: IconProps) {
  return (
    <div className={className}>
      <svg width={width} height={height} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16 31C24.2843 31 31 24.2843 31 16C31 7.71573 24.2843 1 16 1C7.71573 1 1 7.71573 1 16C1 24.2843 7.71573 31 16 31Z" stroke={color} strokeWidth="0.8"/>
      <path d="M18.4997 8.5H15.1663C13.333 8.5 11.833 10 11.833 11.8333C11.833 13.6667 13.333 15.1667 15.1663 15.1667H16.833C18.6663 15.1667 20.1663 16.6667 20.1663 18.5C20.1663 20.3333 18.6663 21.8333 16.833 21.8333H13.4997" stroke={color} strokeWidth="0.8" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M16 6.83337V25.1667" stroke={color} strokeWidth="0.8" strokeLinecap="round"/>
      </svg>
    </div>
  )
}